"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensTable = void 0;
class LensTable {
    angle;
    rp;
    constructor(angle, rp) {
        this.angle = angle;
        this.rp = rp;
        if (angle.length !== rp.length) {
            throw new Error('Invalid lens table, angle and rp must have the same length');
        }
    }
    phi(pixelRadius) {
        for (let i = 1; i < this.rp.length; i++) {
            if (this.rp[i - 1] <= pixelRadius && this.rp[i] >= pixelRadius) {
                // Interpolate the angle by the same proportion that the pixel radius is split between the two values
                return ((pixelRadius - this.rp[i - 1]) * (this.angle[i] - this.angle[i - 1]) / (this.rp[i] - this.rp[i - 1]) + this.angle[i - 1]);
            }
        }
        throw new Error('Invalid pixel radius');
    }
}
exports.LensTable = LensTable;
